import { render, staticRenderFns } from "./FeaturedFunnelList.vue?vue&type=template&id=8b36d1f4"
import script from "./FeaturedFunnelList.vue?vue&type=script&lang=js"
export * from "./FeaturedFunnelList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports